import {
  Autocomplete,
  Box,
  CircularProgress,
  TextField,
  MenuItem,
  Select,
  IconButton,
} from "@mui/material";
import React, { useState, useRef } from "react";
import { X, Search as SearchIcon } from "lucide-react";

interface SearchProps {
  searchPosition: [number, number] | null;
  setSearchPosition: React.Dispatch<
    React.SetStateAction<[number, number] | null>
  >;
}

interface Suggestion {
  display_name: string;
  lat: string;
  lon: string;
}

const Search = ({ searchPosition, setSearchPosition }: SearchProps) => {
  const [searchType, setSearchType] = useState("place");
  const [searchQuery, setSearchQuery] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [suggestions, setSuggestions] = useState<Suggestion[]>([]);
  const [loading, setLoading] = useState(false);
  const debounceTimer = useRef<NodeJS.Timeout | null>(null);

  const handleSearch = async (query: string) => {
    if (!query) {
      setSuggestions([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    debounceTimer.current = setTimeout(async () => {
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
            query
          )}`
        );
        const data = await response.json();
        setSuggestions(data);
      } catch (error) {
        console.error("Error fetching location:", error);
      } finally {
        setLoading(false);
      }
    }, 1000);
  };

  const handleLatLongSearch = async () => {
    if (latitude && longitude) {
      setLoading(true);
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
        );
        const data = await response.json();
        if (data && data.display_name) {
          setSearchPosition([parseFloat(latitude), parseFloat(longitude)]);
          setSuggestions([
            { display_name: data.display_name, lat: latitude, lon: longitude },
          ]);
        }
      } catch (error) {
        console.error("Error fetching lat/long location:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Box display="flex" gap={1} alignItems="center">
      <Select
        value={searchType}
        onChange={(e) => setSearchType(e.target.value)}
        size="small"
        sx={{ bgcolor: "white", width: "auto" }}
      >
        <MenuItem value="place">Place Name</MenuItem>
        <MenuItem value="latlong" disabled>
          Latitude-Longitude
        </MenuItem>
        <MenuItem value="aqsid" disabled>
          AQS-ID/ID
        </MenuItem>
      </Select>

      {searchType === "place" ? (
        <Autocomplete
          sx={{ minWidth: "25vw", width: "auto", bgcolor: "white" }}
          freeSolo
          options={suggestions.map((suggestion) => suggestion.display_name)}
          onInputChange={(event, newInputValue) => {
            setSearchQuery(newInputValue);
            handleSearch(newInputValue);
          }}
          onChange={(event, newValue) => {
            const selected = suggestions.find(
              (item) => item.display_name === newValue
            );
            if (selected) {
              setSearchPosition([
                parseFloat(selected.lat),
                parseFloat(selected.lon),
              ]);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Search Location"
              size="small"
              variant="outlined"
            />
          )}
        />
      ) : searchType === "aqsid" ? (
        // You can render something here for "aqsid" type if needed
        <Autocomplete
          sx={{ minWidth: "25vw", width: "auto", bgcolor: "white" }}
          freeSolo
          options={suggestions.map((suggestion) => suggestion.display_name)}
          onInputChange={(event, newInputValue) => {
            setSearchQuery(newInputValue);
            handleSearch(newInputValue);
          }}
          onChange={(event, newValue) => {
            const selected = suggestions.find(
              (item) => item.display_name === newValue
            );
            if (selected) {
              setSearchPosition([
                parseFloat(selected.lat),
                parseFloat(selected.lon),
              ]);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Search AQS ID / ID"
              size="small"
              variant="outlined"
            />
          )}
        />
      ) : (
        <Box display="flex" gap={1} alignItems="center">
          <TextField
            value={latitude}
            onChange={(e) => setLatitude(e.target.value)}
            placeholder="Latitude"
            size="small"
            sx={{ bgcolor: "white", minWidth: "8vw" }}
            InputProps={{
              endAdornment: (
                <IconButton size="small" onClick={() => setLatitude("")}>
                  <X />
                </IconButton>
              ),
            }}
          />
          <TextField
            value={longitude}
            onChange={(e) => setLongitude(e.target.value)}
            placeholder="Longitude"
            size="small"
            sx={{ bgcolor: "white", minWidth: "8vw" }}
            InputProps={{
              endAdornment: (
                <IconButton size="small" onClick={() => setLongitude("")}>
                  <X />
                </IconButton>
              ),
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                // handleLatLongSearch();
              }
            }}
          />
          <IconButton
            size="small"
            // onClick={handleLatLongSearch}
          >
            <SearchIcon color="white" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default Search;

// import { Autocomplete, Box, CircularProgress, TextField } from "@mui/material";
// import React, { useState, useRef } from "react";
// import { X } from "lucide-react";

// // Define the types for the props
// interface SearchProps {
//   searchPosition: [number, number] | null;
//   setSearchPosition: React.Dispatch<
//     React.SetStateAction<[number, number] | null>
//   >;
// }

// interface Suggestion {
//   display_name: string;
//   lat: string;
//   lon: string;
// }

// const Search = ({ searchPosition, setSearchPosition }: SearchProps) => {
//   const [searchQuery, setSearchQuery] = useState(""); // For the search input
//   const [suggestions, setSuggestions] = useState<Suggestion[]>([]); // To hold search suggestions
//   const [loading, setLoading] = useState(false); // Loading state for fetching
//   const debounceTimer = useRef<NodeJS.Timeout | null>(null); // Ref for debounce timer

//   // Function to handle search and fetch suggestions with debounce
//   const handleSearch = async (query: string) => {
//     if (!query) {
//       setSuggestions([]);
//       setLoading(false);
//       return;
//     }
//     setLoading(true); // Set loading to true while fetching
//     if (debounceTimer.current) {
//       clearTimeout(debounceTimer.current);
//     }
//     debounceTimer.current = setTimeout(async () => {
//       try {
//         const response = await fetch(
//           `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
//             query
//           )}`
//         );
//         const data = await response.json();
//         setSuggestions(data);
//       } catch (error) {
//         console.error("Error fetching location:", error);
//       } finally {
//         setLoading(false); // Set loading to false once the fetch is done
//       }
//     }, 2000); // 2-second debounce
//   };

//   return (
//     <>
//       <Autocomplete
//         sx={{ minWidth: "25vw", width: "auto" }}
//         freeSolo
//         options={suggestions.map((suggestion) => suggestion.display_name)}
//         onInputChange={(event, newInputValue) => {
//           setSearchQuery(newInputValue);
//           handleSearch(newInputValue); // Trigger search with debounce
//         }}
//         onChange={(event, newValue) => {
//           const selected = suggestions.find(
//             (item) => item.display_name === newValue
//           );
//           if (selected) {
//             const { lat, lon } = selected;
//             setSearchPosition([parseFloat(lat), parseFloat(lon)]);
//           }
//         }}
//         renderInput={(params) => (
//           <TextField
//             {...params}
//             placeholder="Search Location or Sensor Name"
//             variant="outlined"
//             size="small"
//             sx={{
//               bgcolor: "white",
//               borderRadius: 1,
//               transition: "max-width 0.3s ease",
//             }}
//             InputProps={{
//               ...params.InputProps,
//               endAdornment: (
//                 <>
//                   {loading ? (
//                     <CircularProgress color="inherit" size={20} />
//                   ) : (
//                     <X
//                       onClick={() => {
//                         setSearchQuery("");
//                         handleSearch(""); // Clear search on clear button click
//                       }}
//                       style={{ cursor: "pointer" }}
//                     />
//                   )}
//                   {params.InputProps.endAdornment}
//                 </>
//               ),
//             }}
//           />
//         )}
//         renderOption={(props, option) => (
//           <Box component="li" {...props}>
//             {option}
//           </Box>
//         )}
//         disableClearable
//         inputValue={searchQuery}
//       />
//     </>
//   );
// };

// export default Search;
